import RichTextCopy from 'components/shared/RichTextCopy/RichTextCopy';
import { TextEditorProps } from 'libs/contentful/props';

import { liveUpdateAttrs } from 'libs/contentful/utils';

const TextEditor = ({ sys, content, sectionName, bulletListStyle }: TextEditorProps) => {
  return (
    <section {...(sectionName != null && { id: encodeURIComponent(sectionName) })}>
      <div className="content-wrapper">
        <div
          className="rich-text-editor container mx-0 my-10 font-serif text-body-serif font-medium text-content-primary max-w-[800px] white-colorway"
          {...liveUpdateAttrs(sys?.id, 'content')}>
          <RichTextCopy copy={content} bulletListStyle={bulletListStyle} />
        </div>
      </div>
    </section>
  );
};

export default TextEditor;
